var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74219 7.58661L3.76562 12.8132C3.60156 12.9538 3.41406 13.0007 3.25 13.0007C3.08594 13.0007 2.92188 12.9538 2.80469 12.86C2.52344 12.6725 2.40625 12.2975 2.54688 11.9694L4.35156 7.75067H1.75C1.42188 7.75067 1.14062 7.56317 1.04688 7.28192C0.929688 6.97723 1 6.64911 1.23438 6.43817L7.23438 1.21161C7.49219 0.977234 7.86719 0.977234 8.14844 1.18817C8.45312 1.37567 8.54688 1.75067 8.40625 2.0788L6.60156 6.27411H9.22656C9.53125 6.27411 9.8125 6.48505 9.92969 6.7663C10.0469 7.04755 9.97656 7.37567 9.74219 7.58661Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowered);
export default __webpack_public_path__ + "static/media/powered.3bc2e3a2850a73085db1a3b552ff1eaa.svg";
export { ForwardRef as ReactComponent };